import { FC, useEffect, useState } from "react";
import { DropDown } from "../../../common/components/DropDown";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  SelectChangeEvent,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { TIME_RANGE } from "../../../common/constants/timeRange";

interface Props {
  onTimeRangeChange: (range: { start: string; end: string } | string) => void;
}

export const QuickTimeRange: FC<Props> = ({ onTimeRangeChange }) => {
  const [selectedTime, setSelectedTime] = useState<string>("custom");
  const [showDateRange, setShowDateRange] = useState<boolean>(false);
  const [startDateRange, setStartDateRange] = useState("");
  const [endDateRange, setEndDateRange] = useState<string>("");

  useEffect(() => {
    onTimeRangeChange({
      start: "2025-06-01T01:00:00.000Z",
      end: "2025-06-30T01:00:00.000Z",
    });
  }, []);

  const handleTimeRange = (e: SelectChangeEvent<string>) => {
    const selectedTimeRange = e.target.value;

    if (selectedTimeRange === "custom") {
      setShowDateRange(true);
      return;
    }

    setSelectedTime(selectedTimeRange);
    onTimeRangeChange(selectedTimeRange);
  };

  const handleCloseTimeRange = () => {
    setShowDateRange(false);
    setSelectedTime("custom");
  };

  const handleCustomRangeApply = () => {
    const start = dayjs(startDateRange).toISOString();
    const end = dayjs(endDateRange).toISOString();

    setSelectedTime(TIME_RANGE[0].value);
    onTimeRangeChange({ start, end });
    setShowDateRange(false);
  };

  const handleOpenDateRange = () => {
    if (selectedTime === "custom") {
      setShowDateRange(true);
    }
  };

  return (
    <>
      <DropDown
        value={selectedTime}
        name="Quick Time Range"
        options={TIME_RANGE}
        onChange={handleTimeRange}
        onClick={handleOpenDateRange}
      />

      <Dialog open={showDateRange}>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-evenly",
              gap: "1rem",
            }}
          >
            <DatePicker
              label="Start Date"
              disableFuture
              value={startDateRange || ""}
              onChange={(value) => setStartDateRange(value as string)}
            />

            <DatePicker
              label="End Date"
              disableFuture
              value={endDateRange || ""}
              onChange={(value) => setEndDateRange(value as string)}
            />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <Button onClick={handleCloseTimeRange}>Cancel</Button>
            <Button
              disabled={!startDateRange || !endDateRange}
              onClick={handleCustomRangeApply}
            >
              Apply
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};
